import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./plugins/vuex";
import "./plugins/vuex-rest";
import "./plugins/v-hover";
import "./plugins/hooper";
import ZoomOnHover from "vue-zoom-on-hover";

import "./styles/main.css";
import "./styles/ck-content.css";

import { server } from "./config";

Vue.config.productionTip = false;

Vue.use(ZoomOnHover);

Vue.mixin({
  data: () => ({
    server,
    files: server,
  }),
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
